export default {
  title_1: 'なぜハードウェアウォレットが必要？',
  desc_1_1:
    'Web3 はスマートコントラクト上に構築されており、多くのユーザーに各種リスクをもたらします。',
  desc_1_2:
    'ウォレットの作成やトランザクション署名の際、使用するスマホやPCは、侵入・マルウェア・クリップボード監視など不明なリスクに晒されます。Web3 をより安全に利用するには専用のセキュリティデバイスが有効です。',
  desc_1_3: 'その最有力な選択肢の一つがハードウェアウォレットです。',

  title_2: 'ハードウェアウォレットはなぜ安全？',
  desc_2_1: 'セキュリティチップ',
  desc_2_2: 'ウォレット作成を支援',
  desc_2_3: '安全な保管',
  desc_2_4: '鍵をオフラインで保管・管理',
  desc_2_5: 'ハッキング回避',
  desc_2_6: '詐欺から遠ざける',

  title_3: 'なぜ KeyPal？',
  desc_3_1: 'デュアルチップ',
  desc_3_2:
    'KeyPal は改ざん耐性のある MCU と SE セキュリティチップによるデュアルチップ保護を採用しています。',
  desc_3_3: '真正性認証',
  desc_3_4:
    '各デバイスは製造時に一意の身元証明書を持ち、背面にはレーザーで一意のシリアル番号を刻印。オンラインの防偽検証に使用されます。',
  desc_3_5: '機微データの送信を防止',
  desc_3_6:
    'KeyPal はデュアルチャネルの Bluetooth と USB でアプリと通信。Bluetooth 通信ではリンク層で機微情報を送信せず、盗聴を防ぎます。',
  desc_3_7: 'PIN コード',
  desc_3_8:
    'ウォレットの作成/復元時に起動 PIN を設定し、起動のたびに正しい PIN が必要。連続して誤入力すると工場出荷時設定にリセットされ、保存データは消去されます。紛失・盗難・誤操作時の不正視聴/利用を防ぎます。',
  desc_3_9:
    'KeyPal は BIP32/BIP39/BIP44 に準拠。オフラインの安全環境でニーモニックを生成・管理・保護します。Bluetooth 暗号化通信、PIN 保護、2.0インチのフルカラー表示により、各署名取引を画面で確認でき「見たものに署名する」を実現。改ざんや中間者攻撃を防止します。',

  SE_desc_1: '1. 真性乱数生成器を内蔵',
  SE_desc_2: '2. 複数の安全ストレージ',
  SE_desc_3: '3. シードがチップ外へ出ない設計',
  SE_desc_4: '4. 総当たり攻撃に耐性・外部読出しを防止',
  MCU_desc_1: '1. 銀行レベルの暗号化',
  MCU_desc_2: '2. システム安全性と改ざん検知',
  MCU_desc_3: '3. 外部攻撃・コードインジェクションに耐性',
};
